import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Users, DollarSign, Video, ShoppingBag, BookOpen, Check, X, Upload, TrendingUp, Crown, Lock, Unlock, Settings, RefreshCw, Globe, Edit3, FileSpreadsheet, AlertCircle, Download, Youtube, Plus, Layers, Calendar, Flag, Star, Trash2, Gift, Ban, UserX, UserCheck, CheckCircle, ShieldCheck, Clock, PartyPopper, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Pot Mgmt tab.
 *
 * Lifted out of AdminPanel.js during the Phase 2 frontend split (Wave 4).
 * Pure presentational — receives parent state + handlers via props.
 */
export default function PotTab(props) {
  const { user, navigate, getAuthHeader, fetchAllData, fileInputRef, users, setUsers, userSearch, setUserSearch, filteredUsers, pendingFounders, founderSettings, setFounderSettings, founderSeatsRemaining, updateFounderSettings, toggleFounderEnrollment, toggleFoundingMember, suspendUser, archiveUser, permanentlyDeleteUser, changeUserTier, sales, pendingSales, pendingListingSales, handleVerifySale, handleVerifyListingSale, handleUnverifyListingSale, handleCancelListingSale, commissionDashboard, promoCodes, newPromo, setNewPromo, createPromoCode, deletePromoCode, promoToDelete, setPromoToDelete, potData, setPotData, updatePot, advertisers, pendingVideos, pendingLibraryVideos, handleBatchApproveVideos, handleVideoReview, handleLibraryVideoReview, moveDownlineData, setMoveDownlineData, featuredMembers, selectedUserToFeature, setSelectedUserToFeature, featuredText, setFeaturedText, handleAddFeaturedMember, handleRemoveFeaturedMember, tierFeatures, editingTier, setEditingTier, editFeatures, setEditFeatures, startEditingTier, saveTierFeatures, customTiers, showTierForm, setShowTierForm, newTier, setNewTier, tierFeaturesInput, setTierFeaturesInput, handleCreateTier, handleDeleteTier, pendingServices, flaggedServices, handleApproveService, handleFlagService, handleDeleteService, edirectoryStatus, syncingEdir, syncEdirectory, importedTransactions, importing, importResult, handleFileSelect, downloadSampleCSV } = props;

  return (
    <div className="space-y-4" data-testid="pot-tab">
      <h2 className="text-2xl font-playfair font-bold text-foreground mb-4">Millionaire Pot Management</h2>
            
                  <div className="wm-card p-6 rounded-lg">
                    <form onSubmit={updatePot} className="space-y-4" data-testid="pot-update-form">
                      <div>
                        <Label htmlFor="total" className="text-foreground">Current Total Amount ($)</Label>
                        <Input
                          id="total"
                          type="number"
                          step="0.01"
                          value={potData.total_amount}
                          onChange={(e) => setPotData({ ...potData, total_amount: parseFloat(e.target.value) })}
                          className="mt-1 bg-input border-border text-foreground"
                          data-testid="pot-total-input"
                        />
                      </div>

                      <div>
                        <Label htmlFor="goal" className="text-foreground">Goal Amount ($)</Label>
                        <Input
                          id="goal"
                          type="number"
                          step="0.01"
                          value={potData.goal_amount}
                          onChange={(e) => setPotData({ ...potData, goal_amount: parseFloat(e.target.value) })}
                          className="mt-1 bg-input border-border text-foreground"
                          data-testid="pot-goal-input"
                        />
                      </div>

                      <Button
                        type="submit"
                        className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
                        data-testid="pot-update-btn"
                      >
                        Update Pot
                      </Button>
                    </form>

                    <div className="mt-6 pt-6 border-t border-border">
                      <h3 className="font-semibold text-foreground mb-2">Current Status</h3>
                      <div className="space-y-2 text-sm">
                        <p className="text-muted-foreground">
                          Progress: {((potData.total_amount / potData.goal_amount) * 100).toFixed(2)}%
                        </p>
                        <p className="text-muted-foreground">
                          Remaining: ${(potData.goal_amount - potData.total_amount).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>
    </div>
  );
}
